import actionCreators from './actionCreators';

import ComponentSeasonAPI from '../../../utils/componentSeasonAPI';

const fetchComponentSeasons = () => async dispatch => {
    dispatch(actionCreators.requestComponentSeasons());

    try {
        const data = await ComponentSeasonAPI.fetchComponentSeasons();
        dispatch(actionCreators.componentSeasonsResponse(true, data.data, null))
    } catch (error) {
        dispatch(actionCreators.componentSeasonsResponse(false, [], error))
    }
};

export default {
    fetchComponentSeasons
};
